function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.949 29.1666L31.9276 34.4149C31.9631 34.6242 31.9424 34.8371 31.867 35.0395C31.7916 35.242 31.6631 35.4296 31.4901 35.5898C31.3171 35.75 31.1034 35.8793 30.8631 35.9691C30.6228 36.0589 30.3613 36.1073 30.0958 36.1111H19.908C19.6412 36.1106 19.3777 36.0643 19.1353 35.9755C18.893 35.8867 18.6776 35.7574 18.5038 35.5965C18.33 35.4355 18.2017 35.2467 18.128 35.0428C18.0542 34.8388 18.0365 34.6247 18.0762 34.4149L19.0297 29.1666",
  stroke: "#E25B0D",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8072 13.8889H16.1928C14.9204 13.8889 13.8889 14.97 13.8889 16.3035V26.7521C13.8889 28.0856 14.9204 29.1667 16.1928 29.1667H33.8072C35.0796 29.1667 36.1111 28.0856 36.1111 26.7521V16.3035C36.1111 14.97 35.0796 13.8889 33.8072 13.8889Z",
  stroke: "#E25B0D",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 20.8333,
  y1: 32.5834,
  x2: 27.7778,
  y2: 32.5834,
  stroke: "#E25B0D",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var SvgCashRegistersNew = function SvgCashRegistersNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCashRegistersNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cash-registers-new.1155634d.svg";
export { ForwardRef as ReactComponent };